module.exports = __webpack_public_path__ + "static/investors-info8-dad0348cf7e590b73fe7904bd40bfe73.jpg";